import ENVIRONMENT from '@/environment';

let loadPromise: Promise<void> | null = null;

const loadChargebeeScript = (): Promise<void> => {
  if (typeof Chargebee !== 'undefined' && Chargebee?.inited) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.onload = () => {
      if (typeof Chargebee !== 'undefined' && !Chargebee.inited) {
        Chargebee.init({ site: ENVIRONMENT.CHARGEBEE_SITE_NAME });
      }
      resolve();
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Chargebee script'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};

export default loadChargebeeScript;
